import React from 'react';

import { cssMap } from '@compiled/react';

import Avatar from '@atlaskit/avatar/avatar';
import { Anchor, Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { PersonElementType } from '../../../types';

const PersonCarouselCardStyles = cssMap({
	personCardContainer: {
		borderRadius: token('radius.large'),
		display: 'flex',
		flexDirection: 'column',
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		maxWidth: '400px',
		textDecoration: 'none',
		'&:hover': {
			backgroundColor: token('color.background.neutral.subtle.hovered'),
			textDecoration: 'none',
		},
	},
	contactInfoSection: {
		marginLeft: token('space.100'),
		flex: 1,
		minWidth: '0px',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
});

interface PersonCarouselCardProps {
	component: PersonElementType;
}

export const RelatedPersonCard = ({ component }: PersonCarouselCardProps): React.JSX.Element => {
	const personAttributes = component.attributes;
	const { name, job_title, avatar_url, url } = personAttributes || {};

	if (!url) {
		return <></>;
	}

	return (
		<Anchor
			href={url}
			xcss={PersonCarouselCardStyles.personCardContainer}
			testId="lumina-layout-person-card"
		>
			<Inline alignBlock="center">
				<Box>
					<Avatar appearance="circle" src={avatar_url || ''} size="large" />
				</Box>
				<Box xcss={PersonCarouselCardStyles.contactInfoSection}>
					<Stack space="space.050">
						<Text weight="bold" size="medium" maxLines={1}>
							{name}
						</Text>
						<Text size="small" color="color.text.subtlest" maxLines={1}>
							{job_title}
						</Text>
					</Stack>
				</Box>
			</Inline>
		</Anchor>
	);
};
